// CYP-225: OnlyOffice off inline (no onlyOfficeEnv import) so
// this overlay builds on cypherWebApp trees without that module.

import {default as data} from '../../package.json';

const environment =
{
    VERSION: data.version,
    production: true,

    // getting the sesstion
    sessionRequested: false,

    apiUrl : 'https://erieapi.cyphersystem.com',
    authUrl : 'https://erieapi.cyphersystem.com',
    courtUrl : 'https://eriecc.cyphersystem.com',

    onlyOfficeEnabled: false,
    onlyOfficeUrl: '',

    sentryDsn:
        'https://2c0b7179e62f28ec52f8432e6d07d245@o4512148365377536' +
        '.ingest.us.sentry.io/4512148375732224',
    sentryEnvironment: 'production'
}

export { environment };
